export default __webpack_public_path__ + "static/media/p2023-40.f60a9ffb.jpeg";